import FullScreenSpinner from '@components/FullScreenSpinner/FullScreenSpinner';
import { withTranslations } from '@utils/pageUtils';

import { NextPage } from 'next';
import dynamic from 'next/dynamic';

const LandingPage = dynamic(() => import('features/landing/LandingPage'), {
  ssr: false,
  loading: () => <FullScreenSpinner />
});

const Landing: NextPage = () => (
  <LandingPage />
);

export async function getServerSideProps({ locale = 'id' }: { locale?: string }) {
  return { props: await withTranslations(locale, locale) };
}

export default Landing;
